export enum FORM_NAME {
  CREATE_FUKUMARU_QUIZ = 'CREATE_FUKUMARU_QUIZ',
  UPDATE_FUKUMARU_QUIZ = 'UPDATE_FUKUMARU_QUIZ',
}
